module.exports = __webpack_public_path__ + "static/media/YF41_1.b1ee33cc.jpg";